var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.60565 1.47867C6.21733 0.391226 7.783 0.391225 8.39469 1.47867L12.8589 9.4151C13.4589 10.4817 12.6881 11.7995 11.4644 11.7995H2.53592C1.3122 11.7995 0.541458 10.4817 1.1414 9.4151L5.60565 1.47867ZM7.8001 9.39961C7.8001 9.84144 7.44193 10.1996 7.0001 10.1996C6.55827 10.1996 6.2001 9.84144 6.2001 9.39961C6.2001 8.95778 6.55827 8.59961 7.0001 8.59961C7.44193 8.59961 7.8001 8.95778 7.8001 9.39961ZM7.0001 2.99961C6.55827 2.99961 6.2001 3.35778 6.2001 3.79961V6.19961C6.2001 6.64144 6.55827 6.99961 7.0001 6.99961C7.44193 6.99961 7.8001 6.64144 7.8001 6.19961V3.79961C7.8001 3.35778 7.44193 2.99961 7.0001 2.99961Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1fdfced0db08e3bed897de2b019eb89f.svg";
export { ForwardRef as ReactComponent };